
import { defineComponent } from "vue";
import Decrement from "../icons/Decrement.vue";
import Increment from "../icons/Increment.vue";

export default defineComponent({
  components: {
    Decrement, Increment,
  },
  props: {
    modelValue: { type: Number, required: true },
    block: { type: Boolean, default: false },
    min: { type: Number, default: 0 },
    max: { type: Number, default: Infinity },
  },
  emits: [
    "update:modelValue",
  ],
  data: (props) => ({
    stringValue: String(props.modelValue),
    stringIsValid: true,
  }),
  watch: {
    modelValue: {
      handler() {
        this.stringValue = String(this.modelValue);
        this.stringIsValid = true;
      },
    },
  },
  methods: {
    onChange(value: string): void {
      const number = Number(value);
      this.stringValue = value;
      this.stringIsValid = value !== ""
                        && Number.isInteger(number)
                        && this.min <= number
                        && number <= this.max;
      if (this.stringIsValid) {
        this.$emit("update:modelValue", Math.min(this.max, Math.max(this.min, number)));
      }
    },
  },
});
